import { getWorkSuggestions } from '@App/api/routes/search'
import { searchSongwriterCatalogSuggestions } from '@App/api/routes/songwriter/songwriter'
import { searchSuggestions } from '@App/api/routes/work'
import { AutoCompleteFetchRequest } from '@App/stores/search/models/select-option-hide'

const getWorkAutoCompleteSuggestions = async ({
    property,
    searchTerm,
    rightsholderId,
    songwriterId,
    signal,
}: AutoCompleteFetchRequest) => {
    let suggestions
    if (rightsholderId) {
        suggestions = await getWorkSuggestions(rightsholderId, property, searchTerm, undefined, signal)
    } else if (songwriterId) {
        suggestions = await searchSongwriterCatalogSuggestions(songwriterId, property, searchTerm, signal)
    } else {
        suggestions = await searchSuggestions(property, searchTerm, undefined, undefined, signal)
    }

    return suggestions.data || []
}

export default getWorkAutoCompleteSuggestions
